import { LowerLanguage } from "src/i18n";

import { Voidable } from "../commons.types";

export const QUESTIONNAIRE_CODE = "Q00";

export enum StripeCheckoutStatus {
  OPEN = "open",
  COMPLETE = "complete",
  EXPIRED = "expired",
}

export enum ViarioNationCode {
  ITALY = "1",
}

export enum ContractorType {
  NATURAL = "F",
  LEGAL = "G",
}

export enum CompanyType {
  ODV = "id_odv",
  APS = "id_aps",
  ASD = "id_asd",
  SSD = "id_ssd",
  REL = "id_rel",
  FOU = "id_fou",
  COO = "id_coo",
  SOC = "id_soc",
  ALT = "id_oth",
}

export enum Gender {
  M = "M",
  F = "F",
}

export enum YesNoAnswersNew {
  YES = "SI",
  NO = "NO",
}

export enum Nationality {
  IT = "italiana",
  EXT = "estero",
}

export enum PeriodType {
  DAILY = "3",
  PERIOD = "4",
}

export enum FileFormat {
  MOBILE = "SM",
  DESKTOP = "XL",
}

export type Token = {
  AuthenticationResult: {
    AccessToken: string;
    ExpiresIn: number;
    IdToken: string;
    RefreshToken: string;
    TokenType: string;
  };
};

export type Dossier = {
  dossierId: string;
  sessionId: string;
  result: string;
  message: string;
  languages: LowerLanguage[];
  prodotti: Product[];
  agenzia: Agency;
};

export type DossierConfiguration = {
  applicativo: string;
  configurazioni: {
    limiteAssicurati: string;
    loghi: Logo[];
    prezzi: ProductPrice[];
    documentiGruppi: Document[];
    cookiesTemplate: CookieTemplates;
    informativaWeb: Message;
  };
};

export type Logo = {
  docCode: string;
  desc: Message;
  fileName: Message;
  filePath: Message;
  link: Message;
};

export type ProductPrice = {
  code: string;
  description: string;
};

export type Product = {
  prodotto: ProductInfo;
  frazionamenti: Fractionation[];
  languages: LowerLanguage[];
  prodottoDesc: string;
  prodottoSottotitolo: string;
  documenti: Document[];
  faq: Faq[];
};

export type ProductInfo = {
  code: string;
  description: string;
};
export type Fractionation = {
  id: string;
  descrizione: string;
  selected: boolean;
};
export type Document = {
  docCode: string;
  desc: Message;
  fileName: Message;
  filePath: Message;
};
export type Faq = {
  faqCode?: string;
  request?: Message;
  answer?: Message;
};

export type Agency = {
  id: string;
  isCustom: boolean;
  ruiNumber?: string;
  operationalHeadquartersCompleteAddress?: AgencyCompleteAddress;
  registeredOfficeCompleteAddress?: AgencyCompleteAddress;
  mail?: string;
  type?: string;
  pecMail?: string;
  denomination?: string;
  phoneNumber?: string;
  name: string;
  documents: Document[];
};

export type AgencyCompleteAddress = {
  country?: string;
  location?: string;
  address?: string;
  province?: string;
  town?: string;
};

export type Policy = {
  idPolizza?: string;
  codProdotto: string;
  dataInizio: number;
  dataFine: number;
  durata: number;
  frazionamenti: Fractionation[];
  premioTotale: number;
  consensi: Consent[];
  tipoContraente: ContractorType;
  contraente: NaturalContractor | LegalContractor;
  assicurati: Insured[];
  garanzie: any[];
  entita: any[];
};

export type NaturalContractor = {
  nome: string;
  cognome: string;
  sesso: Gender;
  email: string;
  telefono: string;
  nazioneNascita: string;
  luogoNascita: string;
  provinciaNascita: string;
  nazionalita: Nationality;
  cap: string;
  dataNascita: number;
  codiceFiscale: string;
  indirizzo: string;
  comune: string;
  provincia: string;
};

export type LegalContractor = {
  cognome: string;
  partitaIva: string;
  email: string;
  telefono: string;
  codiceFiscale: string;
  cap: string;
  indirizzo: string;
  comune: string; // =>  citta legale
  provincia: string;
  fcNotMatchVat: boolean;
  tipo?: CompanyType;
};

export type Insured = {
  nome: string;
  cognome: string;
  dataNascita: number;
  nazioneNascita: string;
  luogoNascita: string;
  codiceFiscale: string;
  sesso: Gender;
  nazionalita: Nationality;
};

export type Consent = {
  cod_consenso: string;
  nome: string;
  descrizione: string;
};

export type Questionnaire = {
  idQuestionario: number;
  codQuestionario: string;
  questionario: {
    isOk: boolean;
    domande: Question[];
  };
};

export type Question = {
  idDomanda: number;
  titolo: string;
  descrizione: string;
  obbligatoria: boolean;
  attiva: boolean;
  risposte: Answer[];
};

export type Answer = {
  idRisposta: number;
  descrizione: string;
  valore: string;
  corretta: boolean;
  preselezionata: boolean;
  selezionata: boolean;
};

export type Message = Record<LowerLanguage, string>;

export type CookieTemplates = {
  startTemplate: Message;
  endTemplate: Message;
};

export type EvaluatePremiumRequest = {
  giorni: number;
  assicurati: number;
  codProdotto: number;
  frazionamento: number;
};

export type EvaluatePremium = {
  premium: { quoteValue?: number };
};

export type GroupAsset = {
  assicurato: {
    idAssicurato?: number;
    nome: string;
    cognome: string;
    nazionalita: string;
    codiceFiscale: string;
    dataNascita: string;
    nazioneNascita: string;
    luogoNascita: string;
    sesso: Voidable<Gender>;
    fiscalCodeQuestion?: string;
  };
  errors?: Record<string, string>;
};

export type Viario = {
  codice: string;
  descrizione: string;
};

export type Certificate = {
  result: boolean;
  message: string;
  fileName: string;
  pathBucket: string;
  file: string;
};

export type StripeCreateCheckoutResponse = {
  message: string;
};

export type StripCheckoutDetails = {
  status: StripeCheckoutStatus;
  customer_email: string;
  //Mappa altri campi all'occorrenza
};

/*StripCheckoutDetails mock:
    return {
      id: "cs_test_a1NGLrJF5ILrfOsy6hD8MSOsW0skzEDmlfX8CueBnOyXTMAFHbYuw1lqLU",
      object: "checkout.session",
      adaptive_pricing: {
        enabled: false,
      },
      after_expiration: null,
      allow_promotion_codes: null,
      amount_subtotal: 1000,
      amount_total: 1000,
      automatic_tax: {
        enabled: false,
        liability: null,
        provider: null,
        status: null,
      },
      billing_address_collection: null,
      cancel_url: null,
      client_reference_id: null,
      client_secret: null,
      collected_information: {
        shipping_details: null,
      },
      consent: null,
      consent_collection: null,
      created: 1750771880,
      currency: "eur",
      currency_conversion: null,
      custom_fields: [],
      custom_text: {
        after_submit: null,
        shipping_address: null,
        submit: null,
        terms_of_service_acceptance: null,
      },
      customer: null,
      customer_creation: "if_required",
      customer_details: {
        address: {
          city: null,
          country: "US",
          line1: null,
          line2: null,
          postal_code: "94080",
          state: null,
        },
        email: "fr.digirolamo@reply.it",
        name: null,
        phone: null,
        tax_exempt: "none",
        tax_ids: [],
      },
      customer_email: "fr.digirolamo@reply.it",
      discounts: [],
      expires_at: 1750858280,
      invoice: null,
      invoice_creation: {
        enabled: false,
        invoice_data: {
          account_tax_ids: null,
          custom_fields: null,
          description: null,
          footer: null,
          issuer: null,
          metadata: {},
          rendering_options: null,
        },
      },
      livemode: false,
      locale: null,
      metadata: {},
      mode: "payment",
      payment_intent: "pi_3RdXZYQiRbNiRPmn0Q5KbjSu",
      payment_link: null,
      payment_method_collection: "if_required",
      payment_method_configuration_details: {
        id: "pmc_1RdRcmQiRbNiRPmnA0iHIarN",
        parent: null,
      },
      payment_method_options: {
        card: {
          request_three_d_secure: "automatic",
        },
      },
      payment_method_types: ["card", "bancontact", "eps", "klarna", "link"],
      payment_status: "paid",
      permissions: null,
      phone_number_collection: {
        enabled: false,
      },
      recovered_from: null,
      return_url:
        "http://localhost:3000/return-checkout?session_id={CHECKOUT_SESSION_ID}",
      saved_payment_method_options: null,
      setup_intent: null,
      shipping_address_collection: null,
      shipping_cost: null,
      shipping_options: [],
      status: "open",
      submit_type: null,
      subscription: null,
      success_url: null,
      total_details: {
        amount_discount: 0,
        amount_shipping: 0,
        amount_tax: 0,
      },
      ui_mode: "custom",
      url: null,
      wallet_options: null,
    };
  };

  return { checkoutSuccess, email, error };
};


*/
